<mat-dialog-content class="custom__class-dialog">
  <img width="48px" height="48px" src="assets/images/icons/success-modal.png" alt="icon success modal">
  <h1>{{ title | translate}}</h1>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="custom__class-bton-modal btn btn-info" mat-dialog-close cdkFocusInitial>{{'modal.button.continue' |
    translate}}</button>
</mat-dialog-actions>